<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/popularize-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">您是否还存在以下痛点？</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/popularize01.png" alt="">
          <span class="title">单量少</span>
          <span class="text">销售业绩上不去广告、<br>促销做了不少，但效果平平</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/popularize02.png" alt="">
          <span class="title">客流量少</span>
          <span class="text">开拓新客拿不准，开拓新客<br>无从下手，找不到精准客群</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/popularize03.png" alt="">
          <span class="title">知名度低</span>
          <span class="text">品牌名称打不响行业龙头<br>垄断，没机会展示优势</span>
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">锁定营销目标 提升转化 降低成本</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/popularize04-1.png" alt="">
          <span>品牌曝光</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/popularize04-2.png" alt="">
          <span>产品售卖</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/popularize04-3.png" alt="">
          <span>客资收集</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/popularize04-4.png" alt="">
          <span>门店引流</span>
        </div>
      </div>
    </div>
    <div class="block-comnon-01 block03">
      <div class="content">
        <div class="item">
          <span class="title">巨量广告</span>
          <div class="line" />
          <span class="text">巨量引擎平台整合了今日头条、抖音、西瓜视频等产品的官方营销平台，用户群体庞大，积累了多维精准定向体系，实现精准投放，高效营销</span>
          <div class="image-wapper">
            <img class="image01" src="@/assets/Mobile/images/solution/popularize05.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="block-comnon-01 block04">
      <div class="content">
        <div class="item">
          <span class="title">腾讯广告</span>
          <div class="line" />
          <span class="text">腾讯平台基于微信、QQ社交海量用户基础，拥有微信广告、微信附近推、qq广告，腾讯视频广告、腾讯新闻广告等，利用专业大数据算法，实现多种投放场景，满足不同投放需求</span>
          <div class="image-wapper">
            <img class="image01" src="@/assets/Mobile/images/solution/popularize06.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="block-comnon-01 block05">
      <div class="content">
        <div class="item">
          <span class="title">快手广告</span>
          <div class="line" />
          <span class="text">国民级流量平台，真实性内容，生活化营销场景，垂直圈层渗透力高，拥有品牌广告、信息流广告、金牛电商等营销产品，满足多种应用场景与推广需求，智能精准匹配</span>
          <div class="image-wapper">
            <img class="image01" src="@/assets/Mobile/images/solution/popularize07.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="block-comnon-01 block06">
      <div class="content">
        <div class="item">
          <span class="title">短视频营销</span>
          <div class="line" />
          <span class="text">自有3000平方制作和拍摄基地，高端拍摄器材、专业直播设备，资深视频拍摄团队，主播团队，根据客户行业匹配合适达人，专注短视频账号代运营、直播运营等定制化内容营销</span>
          <div class="image-wapper">
            <img class="image01" src="@/assets/Mobile/images/solution/popularize08.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="block07">
      <div class="sk-mobile-title">
        <div class="title">专业运营团队服务支持，提供方案</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/popularize09.png" alt="">
          <span class="title">免费营销策划服务</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/popularize10.png" alt="">
          <span class="title">素材加工、美化服务</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/popularize11.png" alt="">
          <span class="title">广告投放优化服务</span>
        </div>
      </div>
    </div>
    <IndustrySolution />
    <Case title="流量推广" />
    <ContactForm info-sources="流量推广" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.Popularize,
  components: {
    ContactForm,
    IndustrySolution,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  .content {
    padding: 15px 0 21px 0;
    display: flex;
    justify-content: space-around;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      width: 110px;
    }
    .title {
      font-size: 9px;
      font-weight: 500;
      color: #595961;
      line-height: 26px;
    }
    .text {
      font-size: 7px;
      color: #8B8FA1;
      line-height: 12px;
    }
  }
  img {
    width: 70px;
    height: 77px;
  }
}
.block02 {
  background-color: #F9F9F9;
  overflow: hidden;
  .content {
    margin: 21px 16px;
    background-color: #fff;
    height: 125px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .item {
      display: flex;
      flex-direction: column;
      img {
        width: 74px;
        height: 74px;
      }
      span {
        font-size: 10px;
        font-weight: 500;
        color: #595961;
        line-height: 14px;
        padding-top: 6px;
      }
    }
  }
}
.block-comnon-01 {
  overflow: hidden;
  .content {
    margin-top: 33px;
    padding: 0 16px;
    .item {
      text-align: left;
      margin-bottom: 38px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      .title {
        font-size: 19px;
        font-weight: 600;
        color: #595961;
        line-height: 27px;
      }
      .line {
        margin: 15px 0;
        width: 12px;
        height: 2px;
        background: #3986FF;
      }
      .text {
        font-size: 14px;
        font-weight: 300;
        color: #333333;
        line-height: 22px;
      }
      .image-wapper {
        padding-top: 38px;
        text-align: center;
      }
    }
  }
}
.block03 {
  .image01 {
    width: 303px;
  }
}
.block04 {
  background-color: #F9F9F9;
  .image01 {
    width: 232px;
  }
}
.block05 {
  .image01 {
    width: 245px;
  }
}
.block06 {
  background-color: #F9F9F9;
  .image01 {
    width: 290px;
  }
}
.block07 {
  .content {
    padding: 22px 0;
    display: flex;
    justify-content: space-around;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      width: 110px;
    }
    .title {
      font-size: 11px;
      font-weight: 500;
      color: #595961;
      margin-top: 13px;
      line-height: 15px;
    }
  }
  img {
    width: 83px;
    height: 85px;
  }
}
</style>
